import { Badge } from '@ds';
import { MdOutlineNotifications } from 'react-icons/md';
import { Link } from 'react-router-dom';

export const NotificationBadge = () => {
  return (
    <Link
      className="flex justify-center shrink-0 items-center ml-auto w-9 h-9 rounded-full bg-base-50 text-base-5 cursor-pointer"
      to="/notifications"
    >
      <Badge
        content=""
        size="sm"
        classNames={{
          badge: 'bg-red border-base-60 left-2 top-2',
        }}
      >
        <MdOutlineNotifications size={24} />
      </Badge>
    </Link>
  );
};
